import { cx } from '@twind/core';
import React from 'react';
import useCustomization from 'app/hooks/useCustomization';
import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { ChatVersion } from 'app/copied/constants/common';

import CloseIcon from '../icons/CloseIcon';

export default function CloseButton({
  onClick,
  className,
  circleClassName,
  id = 'ostro-webchat-close-button',
  useCustomIcon = false,
  ariaLabel = 'Close',
  closeIconClassName,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  circleClassName?: string;
  id?: string;
  useCustomIcon?: boolean;
  ariaLabel?: string;
  closeIconClassName?: string;
}) {
  const customization = useCustomization();
  const webchatVersion = useWebchatVersion();

  const closeButtonDimensions = webchatVersion === ChatVersion.v4_1 ? 'w-[24px] h-[24px]' : 'w-[27px] h-[27px]';
  const closeIconSize = webchatVersion === ChatVersion.v4_1 ? 'w-4' : 'w-2';

  return (
    <button
      id={id}
      aria-label={ariaLabel}
      className={cx('~(h-[44px] w-[44px] text-center flex items-center justify-center cursor-pointer)', className)}
      onClick={onClick}
    >
      <span
        className={cx(
          `~(rounded-full ${closeButtonDimensions} text-center flex items-center justify-center bg-brand-closeButtonBackground)`,
          circleClassName,
          useCustomIcon && 'close-chat-bubble'
        )}
      >
        {useCustomIcon && customization?.close_button_icon ? (
          <img
            src={customization?.close_button_icon}
            alt="Close"
          />
        ) : (
          <CloseIcon
            className={cx('~(text-brand-closeButtonX fill-brand-closeButtonX)', closeIconSize, closeIconClassName)}
          />
        )}
      </span>
    </button>
  );
}
